/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/pages/ApprovalMatrixPage.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Approval Matrix List Page
 *
 ******************************************************************************/

import React, {
    useEffect,
    useState,
} from "react";

import ApprovalMatrixHeader
from "../components/ApprovalMatrixHeader";

import ApprovalMatrixToolbar
from "../components/ApprovalMatrixToolbar";

import ApprovalMatrixTable
from "../components/ApprovalMatrixTable";

import ApprovalMatrixDrawer
from "../components/ApprovalMatrixDrawer";

import useApprovalMatrix
from "../hooks/useApprovalMatrix";

import expenseMasterService from "../../claims/services/expenseMasterService";

export default function ApprovalMatrixPage() {

    const {

        loading,

        saving,

        approvalMatrices,

        workflows,

        approvalLevels,

        departments,

        loadApprovalMatrices,

        loadWorkflows,

        loadApprovalLevels,

        loadDepartments,

        createApprovalMatrix,

        updateApprovalMatrix,

        deleteApprovalMatrix,

        activateApprovalMatrix,

        deactivateApprovalMatrix,

    } = useApprovalMatrix();

    /**
     * --------------------------------------------------------------
     * Drawer State
     * --------------------------------------------------------------
     */

    const [drawerOpen, setDrawerOpen] =
        useState(false);

    const [drawerMode, setDrawerMode] =
        useState("create");

    const [selectedRule, setSelectedRule] =
        useState(null);

    /**
     * --------------------------------------------------------------
     * Filters
     * --------------------------------------------------------------
     */

    const [filters, setFilters] =
        useState({

            search: "",

            workflow_id: "",

            department_id: "",

            is_active: "",

        });

    /**
     * --------------------------------------------------------------
     * Initial Form
     * --------------------------------------------------------------
     */

    const initialFormData = {

        workflow_id: "",

        department_id: "",

        workflow_type: "",

        location_id: "",

        expense_policy_id: "",

        expense_category_id: "",

        expense_type_id: "",

        currency_id: "",

        designation_id: "",

        employee_scope: "ALL",

        employee_id: "",
        approval_level_id: "",

        minimum_amount: "",

        maximum_amount: "",

        priority: 1,

        effective_from: "",

        effective_to: "",

        remarks: "",

        is_default: false,

        is_active: true,


    };

    /**
     * --------------------------------------------------------------
     * Form State
     * --------------------------------------------------------------
     */

    const [formData, setFormData] =
        useState(initialFormData);

    const [errors, setErrors] =
        useState({});

    const [workflowTypes, setWorkflowTypes] =
    useState([]);

    const [locations, setLocations] =
        useState([]);

    const [expensePolicies, setExpensePolicies] =
        useState([]);

    const [expenseCategories, setExpenseCategories] =
        useState([]);

    const [expenseTypes, setExpenseTypes] =
        useState([]);

    const [currencies, setCurrencies] =
        useState([]);

    const [designations, setDesignations] =
        useState([]);

    const [employees, setEmployees] =
        useState([]);
    
    /**
     * --------------------------------------------------------------
     * Load Data
     * --------------------------------------------------------------
     */

    const loadData = async () => {

        await Promise.all([

            loadApprovalMatrices(filters),

            loadWorkflows(),

            loadApprovalLevels(),

            loadDepartments(),

        ]);

    };
    const loadLookups = async () => {

        try {

            const [

                workflowTypesData,

                expensePoliciesData,

                expenseCategoriesData,

                expenseTypesData,

                currenciesData,

            ] = await Promise.all([

                expenseMasterService.listWorkflowTypes(),

                expenseMasterService.listExpensePolicies(),

                expenseMasterService.listExpenseCategories(),

                expenseMasterService.listExpenseTypes(),

                expenseMasterService.listCurrencies(),

            ]);

            setWorkflowTypes(workflowTypesData);

            setExpensePolicies(expensePoliciesData);

            setExpenseCategories(expenseCategoriesData);

            setExpenseTypes(expenseTypesData);

            setCurrencies(currenciesData);
            console.log("Workflow Types", workflowTypes);
            console.log("Expense Policies", expensePolicies);
            console.log("Expense Categories", expenseCategories);
            console.log("Expense Types", expenseTypes);
            console.log("Currencies", currencies);

        }

        catch (error) {

            console.error(error);

        }

    };

    /**
     * --------------------------------------------------------------
     * Initial Load
     * --------------------------------------------------------------
     */

    useEffect(() => {

        loadLookups();
        loadData();


    }, []);
        /**
     * --------------------------------------------------------------
     * Filter Change
     * --------------------------------------------------------------
     */

    const handleFilterChange = (

        field,

        value

    ) => {

        setFilters((prev) => ({

            ...prev,

            [field]: value,

        }));

    };

    /**
     * --------------------------------------------------------------
     * Search
     * --------------------------------------------------------------
     */

    const handleSearch = () => {

        loadData();

    };

    /**
     * --------------------------------------------------------------
     * Reset Filters
     * --------------------------------------------------------------
     */

    const handleReset = () => {

        setFilters({

            search: "",

            workflow_id: "",

            department_id: "",

            is_active: "",

        });

    };

    /**
     * --------------------------------------------------------------
     * Refresh
     * --------------------------------------------------------------
     */

    const handleRefresh = () => {

        loadData();

    };

    /**
     * --------------------------------------------------------------
     * Reset Form
     * --------------------------------------------------------------
     */

    const resetForm = () => {

        setFormData(initialFormData);

        setErrors({});

        setSelectedRule(null);

        setDrawerMode("create");

    };

    /**
     * --------------------------------------------------------------
     * Create
     * --------------------------------------------------------------
     */

    const handleCreate = () => {

        resetForm();

        setDrawerOpen(true);

    };

    /**
     * --------------------------------------------------------------
     * Edit
     * --------------------------------------------------------------
     */

    const handleEdit = (rule) => {

        setDrawerMode("edit");

        setSelectedRule(rule);

        setFormData({

            ...initialFormData,

            ...rule,

        });

        setErrors({});

        setDrawerOpen(true);

    };

    /**
     * --------------------------------------------------------------
     * Close Drawer
     * --------------------------------------------------------------
     */

    const handleDrawerClose = () => {

        resetForm();

        setDrawerOpen(false);

    };

    /**
     * --------------------------------------------------------------
     * Form Change
     * --------------------------------------------------------------
     */

    const handleFormChange = (

        field,

        value

    ) => {

        setFormData((prev) => ({

            ...prev,

            [field]: value,

        }));

    };
        /**
     * --------------------------------------------------------------
     * Save Approval Matrix
     * --------------------------------------------------------------
     */

    const handleSubmit = async (event) => {

        event.preventDefault();

        const validationErrors = {};

        if (!formData.workflow_id) {

            validationErrors.workflow_id =
                "Workflow is required.";

        }

        if (!formData.priority) {

            validationErrors.priority =
                "Priority is required.";

        }

        if (

            formData.minimum_amount === "" ||

            formData.minimum_amount === null ||

            formData.minimum_amount === undefined

        ) {

            validationErrors.minimum_amount =
                "Minimum Amount is required.";

        }

        if (

            formData.maximum_amount !== "" &&

            Number(formData.maximum_amount) <

            Number(formData.minimum_amount)

        ) {

            validationErrors.maximum_amount =
                "Maximum Amount cannot be less than Minimum Amount.";

        }

        if (

            Object.keys(validationErrors).length > 0

        ) {

            setErrors(validationErrors);

            return;

        }

        try {

            setErrors({});

            if (

                drawerMode === "create"

            ) {

                await createApprovalMatrix(

                    formData

                );

            }

            else {

                await updateApprovalMatrix(

                    selectedRule.approval_matrix_id,

                    formData

                );

            }

            handleDrawerClose();

            loadData();

        }

        catch (error) {

            console.error(error);

        }

    };

    /**
     * --------------------------------------------------------------
     * Delete
     * --------------------------------------------------------------
     */

    const handleDelete = async (

        rule

    ) => {

        if (

            !window.confirm(

                "Are you sure you want to delete this Approval Matrix Rule?"

            )

        ) {

            return;

        }

        try {

            await deleteApprovalMatrix(

                rule.approval_matrix_id

            );

            loadData();

        }

        catch (error) {

            console.error(error);

        }

    };

    /**
     * --------------------------------------------------------------
     * Activate
     * --------------------------------------------------------------
     */

    const handleActivate = async (

        rule

    ) => {

        try {

            await activateApprovalMatrix(

                rule.approval_matrix_id

            );

            loadData();

        }

        catch (error) {

            console.error(error);

        }

    };

    /**
     * --------------------------------------------------------------
     * Deactivate
     * --------------------------------------------------------------
     */

    const handleDeactivate = async (

        rule

    ) => {

        try {

            await deactivateApprovalMatrix(

                rule.approval_matrix_id

            );

            loadData();

        }

        catch (error) {

            console.error(error);

        }

    };
        /**
     * --------------------------------------------------------------
     * Render
     * --------------------------------------------------------------
     */

    return (

        <>

            <ApprovalMatrixHeader

                title="Approval Matrix"

                subtitle="Configure Approval Rules"

                actions={

                    <button

                        className="btn btn-primary"

                        onClick={handleCreate}

                    >

                        + New Rule

                    </button>

                }

            />

            <ApprovalMatrixToolbar

                filters={filters}

                workflows={workflows}

                departments={departments}

                onFilterChange={handleFilterChange}

                onSearch={handleSearch}

                onReset={handleReset}

                onRefresh={handleRefresh}

                onCreate={handleCreate}

            />

            <ApprovalMatrixTable

                loading={loading}

                approvalMatrices={approvalMatrices}

                onEdit={handleEdit}

                onDelete={handleDelete}

                onActivate={handleActivate}

                onDeactivate={handleDeactivate}

            />

            <ApprovalMatrixDrawer

                open={drawerOpen}

                mode={drawerMode}

                approvalMatrix={selectedRule}

                formData={formData}

                errors={errors}

                loading={loading}

                saving={saving}

                workflows={workflows}

                workflowTypes={workflowTypes}

                approvalLevels={approvalLevels}

                departments={departments}

                locations={locations}

                expensePolicies={expensePolicies}

                expenseCategories={expenseCategories}

                expenseTypes={expenseTypes}

                currencies={currencies}

                designations={designations}

                employees={employees}

                onChange={handleFormChange}

                onSubmit={handleSubmit}

                onClose={handleDrawerClose}

            />

        </>

    );

}